import React from "react";

import InstantSearch from "../../../ui/components/InstantSearch/InstantSearch";

import useSuperAdminDashboardStatistics from "../../hooks/useSuperAdminDashboardStatistics";

import Dashboard from "./Dashboard";

function SuperAdminDashboardStatistics() {
	const statistics = useSuperAdminDashboardStatistics();

	return <Dashboard statistics={statistics} />;
}

export default function SuperAdminDashboard() {
	return (
		<InstantSearch indexName="articles">
			<SuperAdminDashboardStatistics />
		</InstantSearch>
	);
}
